import React from 'react';
import { t } from '../../services/HelperService';
import { AccentAssistantChatPanel, AccentAssistantDock } from './AccentAssistantChatPanel';

/**
 * The PRODUCT EXPLAINER configuration of the generic assistant dock (see
 * AccentAssistantChatPanel.js): diagnostic questions about a configured job line —
 * "why can't I see option X when I select Y?", "why is option Z priced at $20?" —
 * chatted in a docked panel beside the configuration being edited.
 *
 * explainerChat is the host contract: { buildContextJson, getSession, setSession }.
 * Hosts: the job line editor (MultiJobLine in JobLineView.js, one session per primary
 * line) and the price details table (JobPriceDetailsCtrl, one session per line row);
 * both own the end-session cleanup via ProductExplainerLauncher.dispose.
 * buildContextJson runs on EVERY send, so the assistant always sees the line's
 * current options and dimensions.
 *
 * Title/placeholder are kept in sync with the productExplainer profile's dialogTitle
 * and chatPlaceholder (queryShapingSessionProfiles.js) — duplicated here so this
 * bundle doesn't pull in the registry's preview-component imports.
 */
export const ProductExplainerDock = ({ children, explainerChat, onClose }) => (
  <AccentAssistantDock
    panel={
      <AccentAssistantChatPanel
        sessionProfile="productExplainer"
        title={t('Product & Pricing Assistant')}
        placeholder={t('Ask about this configuration (e.g. "why can\u2019t I see option X when I select Y?" or "why is option Z priced at $20?")...')}
        buildRequestFields={() => ({
          explainContextJson: (explainerChat?.buildContextJson?.() ?? '').trim() || undefined,
        })}
        session={explainerChat?.getSession?.()}
        onSessionChange={explainerChat?.setSession}
        onClose={onClose}
      />
    }
  >
    {children}
  </AccentAssistantDock>
);
